export default __webpack_public_path__ + "27e6c051c7aefbe93d38110dfa068e1a.gif";